export default __webpack_public_path__ + "static/media/edit_black_24dp.9b527df0.svg";